export const POS_ROLES = [
    "SUPER_ADMIN",
    "OPERATIONS_MANAGER",
    "POS_TECHNICIAN",
];

export const POS_OPERATION_ROLES = [
    "SUPER_ADMIN",
    "OPERATIONS_MANAGER",
    "POS_TECHNICIAN",
];

export const POS_INVENTORY_ROLES = [
    "SUPER_ADMIN",
    "OPERATIONS_MANAGER",
    "POS_TECHNICIAN",
];

export const POS_PRODUCT_MANAGE_ROLES = ["SUPER_ADMIN"];

export const POS_OPENING_STOCK_ROLES = ["SUPER_ADMIN"];

export const POS_PURCHASE_CREATE_ROLES = ["SUPER_ADMIN", "OPERATIONS_MANAGER"];

export const POS_USED_PART_ACTION_ROLES = ["SUPER_ADMIN", "OPERATIONS_MANAGER"];

export const posRoleLabels = {
    POS_TECHNICIAN: "POS Technician",
};
